import React from 'react';
import { FaBook, FaUsers, FaMapMarkedAlt, FaRoute } from 'react-icons/fa';
import { useScrambleText } from '../hooks/useScrambleText';
import useVisibility from '../hooks/useVisibility';
import { useCountUp } from '../hooks/useCountUp';

const StatCard = ({ icon, number, label, isVisible }) => {
  const targetNumber = parseFloat(number.replace(/[^\d.]/g, ''));
  const animatedNumber = useCountUp(isVisible ? targetNumber : 0);

  return (
    // Updated: Removed hover effects from individual cards
    <div className="bg-slate-800 rounded-lg p-6 flex items-center space-x-4">
      <div className="bg-amber-400 p-3 rounded-full">
        {icon}
      </div>
      <div>
        <p className="font-bold text-2xl text-white">
          {animatedNumber}
          {number.match(/[k+]/) ? number.match(/[k+]/)[0] : ''}
        </p>
        <p className="text-slate-400">{label}</p>
      </div>
    </div>
  );
};

const Stats = () => {
  const [statsRef, isVisible] = useVisibility();
  const [displayText] = useScrambleText("Facts In Numbers", isVisible);

  return (
    <section 
      className="px-4 sm:px-6 lg:px-8 py-8 bg-slate-950" 
      ref={statsRef}
    >
      {/* Updated: Added the scale effect to the main container */}
      <div className="bg-slate-800 rounded-3xl py-16 px-8 transition-all duration-300 ease-in-out hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)] hover:scale-[1.02]">
        <h2 className="text-3xl font-bold text-white text-center mb-12">
          {displayText}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <StatCard 
            icon={<FaBook className="text-slate-950 text-2xl" />} 
            number="1548+" 
            label="Bookings"
            isVisible={isVisible}
          />
          <StatCard 
            icon={<FaUsers className="text-slate-950 text-2xl" />} 
            number="216k+" 
            label="Happy Users"
            isVisible={isVisible}
          />
          <StatCard 
            icon={<FaMapMarkedAlt className="text-slate-950 text-2xl" />} 
            number="85+" 
            label="Locations"
            isVisible={isVisible}
          />
          <StatCard 
            icon={<FaRoute className="text-slate-950 text-2xl" />} 
            number="20k+" 
            label="Km/day"
            isVisible={isVisible}
          />
        </div>
      </div>
    </section>
  );
}

export default Stats;